import { CoordSet } from './CoordSet';
export class PieceThreat {
    directThreats;
    mover;
    constructor(directThreats, mover) {
        this.directThreats = directThreats;
        this.mover = mover;
    }
    equals(other) {
        return other.directThreats.equals(this.directThreats) &&
            other.mover.equals(this.mover);
    }
}
export class SandwichThreat extends PieceThreat {
    directThreat;
    constructor(directThreat, mover) {
        super(new CoordSet([directThreat]), mover);
        this.directThreat = directThreat;
    }
}
